import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';

const OfferHeader = props => {
  const {
    isPreScreen,
    headerClass,
    hideClass,
    cardUiModuleConfiguration,
    children,
    showHighlightFirstCard,
  } = props;
  const { borderColor, borderTitle } = cardUiModuleConfiguration || {};

  const headerClassName = classnames(
    'flex-container recommendHeader bold fontWhite m-text-14 pad8 justify-center align-items-center',
    headerClass,
    hideClass,
  );

  const titleStyle = {
    backgroundColor: borderColor,
  };

  const headerStyle = {
    border: `2px solid ${borderColor}`,
  };

  if (showHighlightFirstCard) {
    return (
      <>
        <FlexContainer
          column
          className={`secondary_border_light border-rad4px`}
        >
          <Label
            type="text-center"
            className={`${headerClassName} secondary_cta_bg_light `}
          >
            {'RECOMMENDED'}
          </Label>
          <div>{children}</div>
        </FlexContainer>
      </>
    );
  } else if (isPreScreen && borderColor && borderTitle) {
    return (
      <>
        <FlexContainer
          column
          className={`${hideClass} border-rad8px`}
          style={headerStyle}
        >
          <Label
            type="text-center"
            className={headerClassName}
            style={titleStyle}
          >
            {borderTitle}
          </Label>
          <div>{children}</div>
        </FlexContainer>
      </>
    );
  } else {
    return <>{children}</>;
  }
};

export default OfferHeader;
